import { MutableRefObject } from 'react';

const useAuthTokens = ({
  token,
  getAuthTokens,
}: {
  token: MutableRefObject<string>;
  getAuthTokens: (options?: any) => Promise<any>;
}) => {
  const fetchAndSetTokens = async (options?: any) => {
    const sessionTokens = await getAuthTokens(options);

    const accessToken = sessionTokens?.accessToken.toString();

    if (!accessToken) {
      token.current = '';
      throw new Error('No access token');
    }

    token.current = accessToken;

    return sessionTokens;
  };

  const calculateDurationBeforeRefreshingToken = (
    expFromToken: number,
  ): number => {
    const computedDateFromExp = new Date(expFromToken * 1000);
    const nowDate = new Date();
    return computedDateFromExp.getTime() - nowDate.getTime();
  };

  const refreshToken = (delay: number) => {
    const expFromToken = calculateDurationBeforeRefreshingToken(delay);

    setTimeout(async () => {
      const sessionTokens = await fetchAndSetTokens({ forceRefresh: true });

      const exp = sessionTokens?.accessToken?.payload?.exp;
      if (exp) {
        refreshToken(exp);
      }
    }, expFromToken - 30000);
  };

  return {
    refreshAuthToken: refreshToken,
    fetchAndSetAuthTokens: fetchAndSetTokens,
  };
};

export default useAuthTokens;
